/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * MDLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {ArchiveFoldersBody} from './schemas/archive-folders-body';

import type {AttachFolderLinksBody} from './schemas/attach-folder-links-body';

import type {CreateFolder200} from './schemas/create-folder200';

import type {CrupdateFolderBody} from './schemas/crupdate-folder-body';

import type {DeleteFoldersParams} from './schemas/delete-folders-params';

import type {DetachFolderLinksBody} from './schemas/detach-folder-links-body';

import type {ExportFoldersCsvBody} from './schemas/export-folders-csv-body';

import type {ExportFoldersCsv200} from './schemas/export-folders-csv200';

import type {ListFoldersParams} from './schemas/list-folders-params';

import type {ListFolders200} from './schemas/list-folders200';

import type {RetrieveFolder200} from './schemas/retrieve-folder200';

import type {UnarchiveFoldersBody} from './schemas/unarchive-folders-body';

import type {UpdateFolder200} from './schemas/update-folder200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all folders
 */
export const listFolders = (
  params?: ListFoldersParams,
  options?: SecondParameter<typeof orvalApiFetch<ListFolders200>>,
) => {
  return orvalApiFetch<ListFolders200>(
    {url: `/folders`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Create a folder
 */
export const createFolder = (
  crupdateFolderBody: CrupdateFolderBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateFolder200>>,
) => {
  return orvalApiFetch<CreateFolder200>(
    {
      url: `/folders`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: crupdateFolderBody,
    },
    options,
  );
};
/**
 * @summary Retrieve a folder
 */
export const retrieveFolder = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveFolder200>>,
) => {
  return orvalApiFetch<RetrieveFolder200>(
    {url: `/folders/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a folder
 */
export const updateFolder = (
  id: number,
  crupdateFolderBody: CrupdateFolderBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateFolder200>>,
) => {
  return orvalApiFetch<UpdateFolder200>(
    {
      url: `/folders/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: crupdateFolderBody,
    },
    options,
  );
};
/**
 * @summary Delete multiple folders
 */
export const deleteFolders = (
  params: DeleteFoldersParams,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/folders/bulk`, method: 'DELETE', params},
    options,
  );
};
/**
 * @summary Archive folders
 */
export const archiveFolders = (
  archiveFoldersBody: ArchiveFoldersBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/folders/bulk/archive`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: archiveFoldersBody,
    },
    options,
  );
};
/**
 * @summary Unarchive folders
 */
export const unarchiveFolders = (
  unarchiveFoldersBody: UnarchiveFoldersBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/folders/bulk/unarchive`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: unarchiveFoldersBody,
    },
    options,
  );
};
/**
 * @summary Export folders as CSV
 */
export const exportFoldersCsv = (
  exportFoldersCsvBody: ExportFoldersCsvBody,
  options?: SecondParameter<typeof orvalApiFetch<ExportFoldersCsv200>>,
) => {
  return orvalApiFetch<ExportFoldersCsv200>(
    {
      url: `/folders/csv/export`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: exportFoldersCsvBody,
    },
    options,
  );
};
/**
 * @summary Attach links to a folder
 */
export const attachFolderLinks = (
  id: number,
  attachFolderLinksBody: AttachFolderLinksBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/folders/${id}/links/attach`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: attachFolderLinksBody,
    },
    options,
  );
};
/**
 * @summary Detach links from a folder
 */
export const detachFolderLinks = (
  id: number,
  detachFolderLinksBody: DetachFolderLinksBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/folders/${id}/links/detach`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: detachFolderLinksBody,
    },
    options,
  );
};
export type ListFoldersResult = NonNullable<
  Awaited<ReturnType<typeof listFolders>>
>;
export type CreateFolderResult = NonNullable<
  Awaited<ReturnType<typeof createFolder>>
>;
export type RetrieveFolderResult = NonNullable<
  Awaited<ReturnType<typeof retrieveFolder>>
>;
export type UpdateFolderResult = NonNullable<
  Awaited<ReturnType<typeof updateFolder>>
>;
export type DeleteFoldersResult = NonNullable<
  Awaited<ReturnType<typeof deleteFolders>>
>;
export type ArchiveFoldersResult = NonNullable<
  Awaited<ReturnType<typeof archiveFolders>>
>;
export type UnarchiveFoldersResult = NonNullable<
  Awaited<ReturnType<typeof unarchiveFolders>>
>;
export type ExportFoldersCsvResult = NonNullable<
  Awaited<ReturnType<typeof exportFoldersCsv>>
>;
export type AttachFolderLinksResult = NonNullable<
  Awaited<ReturnType<typeof attachFolderLinks>>
>;
export type DetachFolderLinksResult = NonNullable<
  Awaited<ReturnType<typeof detachFolderLinks>>
>;
